/**
 * i18n init — sets up i18next with our 4 supported languages.
 *
 * Language preference is stored twice:
 *   • localStorage (`pfo_language`) so it loads instantly on every visit
 *   • the user's server-side profile (`language`) so it follows across
 *     devices — synced by LanguageContext when the user is signed in.
 *
 * English is the default. Falling back to English keeps unknown keys
 * discoverable during rollout rather than showing blanks.
 */

import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en.json";
import ar from "./locales/ar.json";
import hi from "./locales/hi.json";
import ur from "./locales/ur.json";

export const SUPPORTED_LANGUAGES = [
  { code: "en", label: "English",  native: "English",  dir: "ltr" },
  { code: "ar", label: "Arabic",   native: "العربية",  dir: "rtl" },
  { code: "hi", label: "Hindi",    native: "हिन्दी",    dir: "ltr" },
  { code: "ur", label: "Urdu",     native: "اردو",     dir: "rtl" },
];

export const STORAGE_KEY = "pfo_language";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      ar: { translation: ar },
      hi: { translation: hi },
      ur: { translation: ur },
    },
    fallbackLng: "en",
    supportedLngs: SUPPORTED_LANGUAGES.map((l) => l.code),
    interpolation: { escapeValue: false },   // React already escapes
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: STORAGE_KEY,
      caches: ["localStorage"],
    },
    returnEmptyString: false,
  });

export default i18n;
